import PropTypes from "prop-types";
import styles from "./AddressSettings.module.css";
import CheckItem from "Shared/CheckItem";
import Button from "Shared/Button";
import TrashButton from "components/TrashButton";
import Toggler from "components/Toggler";
import { useTranslation } from "react-i18next";

/**
 * Interactive component, A setting where you can delete, edit, set as primary, or default the address.
 */
export function AddressSettings({
  onSetDefault,
  onDelete,
  onEdit,
  onTogglePrimary,
  isDefault,
  isPrimary,
}) {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.checkItem}>
        <CheckItem
          itemTitle={t("Set as my default shipping address")}
          isChecked={isDefault}
          onClick={onSetDefault}
        />
      </div>
      <div className={styles.actionRow}>
        <div className={styles.toggler}>
          <span className={styles.togglerLabel}>Primary: </span>
          <Toggler
            toggled={isPrimary}
            color="#39B54A"
            onChange={onTogglePrimary}
          />
        </div>
        <div className={styles.button}>
          <Button text={t("Edit")} className="editBtn" onClick={onEdit} />
        </div>
        <div className={styles.trash}>
          <TrashButton onClick={onDelete} />
        </div>
      </div>
    </div>
  );
}

AddressSettings.propTypes = {
  onSetDefault: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onTogglePrimary: PropTypes.func,
  isDefault: PropTypes.bool,
  isPrimary: PropTypes.bool,
};
